'use strict';

angular.module('magtac')
  .controller('LibrariesManagementCtrl', [
    '$scope', 'librariesManagementViewModel', '$stateParams',
    function ($scope, viewModel, $stateParams) {
      $scope.model = new viewModel();
    }
  ]);
